type ProfileAvatarProps = {
  displayName: string | null | undefined;
  avatarUrl?: string | null;
  size?: number;
};

export function ProfileAvatar({ displayName, avatarUrl = null, size = 120 }: ProfileAvatarProps) {
  const initial = displayName?.trim().slice(0, 1).toUpperCase() || 'Х';

  return (
    <span
      className="profile-settings-avatar"
      style={{ width: size, height: size, fontSize: Math.max(18, Math.round(size * 0.34)) }}
      aria-label={displayName ?? 'Пользователь Хоппера'}
    >
      {avatarUrl ? <img src={avatarUrl} alt="" aria-hidden="true" /> : <span aria-hidden="true">{initial}</span>}
    </span>
  );
}
